import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ValidationErrorDescription } from '../../../../../validators/validators-with-message/validation-error-description';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent implements OnInit {
  constructor(private elementRef: ElementRef) {
    this.buildClassesArray();
  }
  private _required = false;
  private errorMsg: string;
  private errorHandler: (ValidationErrors?) => string;

  private classesArray;

  @Input() control: UntypedFormControl = null;
  @Input() label: string;
  @Input() mobileSize = 12;
  @Input() desktopSize: number;
  @Input() ipadSize: number;
  @Input() desktopLargeSize: number;
  @Input() desktopXLSize: number;
  private errorsVisible: boolean;

  @Input() set required(value: boolean) {
    this._required = true;
    if (value.valueOf() === false) {
      this._required = false;
    }
  }

  @HostBinding('class')
  get classe() {
    return this.classesArray;
  }

  private buildClassesArray() {
    const domClasses = new Array<string>();
    for (let i = 0; i < this.elementRef.nativeElement.classList.length; i++) {
      if (!this.elementRef.nativeElement.classList[i].startsWith('grid_col')) {
        domClasses.push(this.elementRef.nativeElement.classList[i]);
      }
    }

    this.classesArray = [
      this.getMobileSizeClass(),
      this.getIPadSizeClass(),
      this.getDesktopSizeClass(),
      this.getDesktopLargeClass(),
      this.getDesktopXLClass(),
      ...domClasses,
    ].join(' ');
  }

  private getMobileSizeClass() {
    return `grid_col-sm-${this.mobileSize}`;
  }

  private getDesktopSizeClass() {
    if (this.desktopSize != null) {
      return `grid_col-${this.desktopSize}`;
    } else {
      return '';
    }
  }

  private getIPadSizeClass() {
    if (this.ipadSize != null) {
      return `grid_col-md-${this.ipadSize}`;
    } else {
      return '';
    }
  }

  private getDesktopLargeClass() {
    if (this.desktopLargeSize != null) {
      return `grid_col-lg-${this.desktopLargeSize}`;
    } else {
      return '';
    }
  }

  private getDesktopXLClass() {
    if (this.desktopXLSize != null) {
      return `grid_col-xl-${this.desktopXLSize}`;
    } else {
      return '';
    }
  }

  ngOnInit() {
    this.buildClassesArray();
  }

  get required() {
    return this._required;
  }

  @Input() set errorMessage(value: string | ((ValidationErrors?) => string)) {
    if (typeof value == 'string') {
      this.errorMsg = value;
    } else {
      this.errorHandler = value;
    }
  }

  private getFirstError(errors): {key: string; value: any} {
    const keys = Object.keys(errors);
    if (keys.length > 0) {
      const first = keys[0];
      return {key: first, value: errors[first]};
    }
  }

  getError() {
    const errors = this.control.errors;
    if (this.errorHandler != null) {
      return this.errorHandler(errors);
    } else if (this.errorMsg != null) {
      return this.errorMsg;
    } else {
      const firstError = this.getFirstError(errors);
      if (firstError.value instanceof ValidationErrorDescription) {
        const validationError = firstError.value as ValidationErrorDescription;
        return validationError.getValidationMessage(this.control.value);
      } else if (this.errorMsg != null) {
        return this.errorMsg;
      }
    }
  }

  errorsAreVisible() {
    return this.control != null && this.control.dirty && this.control.invalid && this.errorsVisible;
  }

  showErrors(makeDirty: boolean = true) {
    this.errorsVisible = true;
    if (this.control && makeDirty) {
      this.control.markAsDirty();
    }
  }

  hideErrors() {
    this.errorsVisible = false;
  }

  errorMessageIsVisible() {
    return this.control != null && this.errorsAreVisible() && this.control.errors != null && this.getError() != '';
  }
}
